import { useQuery } from "@tanstack/react-query"
import { getRfqAdminToSellerById } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetRfqAdminToSellerById(id: string, enabled: boolean = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["admin-seller-rfq-detail", id],
    queryFn: () => getRfqAdminToSellerById(id, accessToken!),
    enabled: !!accessToken && !!id && enabled,
    staleTime:0,
  })
}
